import {neverland as $, html, useState} from 'neverland';
import { forgotPassword } from '../lib/cognito.js';

const ForgotPasswordPage = $(function(auth, setAuth, theme) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function getLogo() {
    if (theme && theme.logo && theme.logo !== '') {
      return '/static/img/logos-large/' + theme.logo;
    }
    return '/static/img/transparent-placeholder.png';
  }

  function InfoTip(text) {
    return html`<span class="info-tip" title="${text}"><i class="fal fa-info-circle"></i></span>`;
  }

  async function handleSubmit() {
    setError('');
    setLoading(true);

    const email = document.querySelector('#forgot-email').value.trim().toLowerCase();

    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    try {
      await forgotPassword(email);
      setAuth(prev => ({
        ...prev,
        mfaPage: 'ResetPassword',
        resetEmail: email
      }));
    } catch (err) {
      if (err.code === 'UserNotFoundException') {
        setError('No account found with that email.');
      } else if (err.code === 'LimitExceededException') {
        setError('Too many attempts. Please try again later.');
      } else {
        setError(`Failed to send reset code: ${err.message || 'Unknown error'}`);
      }
    }

    setLoading(false);
  }

  function handleKeyPress(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      handleSubmit();
    }
  }

  function goBack() {
    setAuth(prev => ({ ...prev, mfaPage: null }));
  }

  return html`
    <div class="centre-box login">
      <img src="${getLogo()}" class="squiggle logo-large" />

      <div id="login">
        <h2 style="margin-bottom: 10px; font-size: 1.2em;">Forgot Password</h2>
        <p style="margin-bottom: 12px; font-size: 1em; opacity: 0.8;">
          Enter your email and we'll send you a code to reset your password.
        </p>

        <span class="loginlabel">EMAIL ${InfoTip('The email address you registered with. e.g. \"j.smith@greenvalley.edu.au\"')}</span>
        <input type="email" id="forgot-email" class="login-field" placeholder="you@yourschool.edu.au" onkeyup=${handleKeyPress} /><br />

        <button id="login-submit" onclick=${handleSubmit} disabled=${loading}>
          ${loading ? 'Sending...' : html`<i class="fal fa-envelope"></i>&ensp;SEND RESET CODE`}
        </button>

        <button class="back-link" onclick=${goBack}>
          &larr; Back to Login
        </button>

        ${error ? html`<div class="error"><strong>ERROR</strong><p>${error}</p></div>` : ''}
      </div>
    </div>
  `;
});

export default ForgotPasswordPage;
